<well-signup-card-layout [title]="'signup.companyInfo.title' | translate" [icon]="true">
  <i [ngClass]="iconClass" rightIcon></i>
  <signup-legal-entity-inputs (save)="onSave($event)" [type]="companyType" body>
  </signup-legal-entity-inputs>
</well-signup-card-layout>

<p-dialog [modal]="true"
          [(visible)]="confirmDialogVisible"
          [closable]="false"
          [header]="'signup.companyInfo.confirmLegalEntitySignup' | translate"
>
  <form class="col-12 px-4">
    <div class="row pt-3 pb-4" *ngIf="confirmPasswordErrorMessages && confirmPasswordErrorMessages.length > 0">
      <p-messages [(value)]="confirmPasswordErrorMessages"></p-messages>
    </div>
    <div class="row">
      <div class="login-wrapper col-12">
        <div class="row text pb-5">
          <label class="text-container col-12" for="password">{{'signup.password' | translate}}</label>
          <div class="col-12">
            <p-password id="password" size="30"
                        [toggleMask]="true"
                        [feedback]="false"
                        class="w-100"
                        inputStyleClass='w-100'
                        styleClass='w-100'
                        data-testid="password"
                        [(ngModel)]="loginDetails.password" name="password"></p-password>
          </div>
        </div>
        <div class="row pt-3 pb-4">
          <div class="d-flex flex-column col-12">
            <button pButton type="submit" [label]="'signup.confirm' | translate" style="border-radius: 10px"
                    data-testid="submitButton"
                    class="login-button" (click)="confirmPassword()">
            </button>
          </div>
        </div>
      </div>
    </div>
  </form>
</p-dialog>


